// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Rgg96QQ7SB0ig1 {
  display: block;
  padding-left: var(--ds-space-075, 5px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
}
.Rgg96QQ7SB0ig1 a {
  font-weight: var(--ds-font-weight-bold, bold);
}
.Bl61v_Wi3cNJqp {
  padding-left: var(--ds-space-050, 4px);
  vertical-align: middle;
}
`, ""]);
// Exports
export var memberActivityDetails = `Rgg96QQ7SB0ig1`;
export var visibilityIcon = `Bl61v_Wi3cNJqp`;
export default ___CSS_LOADER_EXPORT___;
